// extracted by mini-css-extract-plugin
module.exports = {"iulTitle":"iul_iulTitle__ro1pl"};